import { Grid } from "@mui/material";
import { useSuperAdminUserRole } from "../../../../context/SuperAdmin/UserRoleContext";
import { Spinner } from "../../../Loading/Spinner";
import HeadersUsersRole from "./HeadersUsersRole";
import SingleRoleUsersTable from "./SingleRoleUsersTable";
import AddUserModal from "./AddUserModal";
import DeleteUsersModal from "./DeleteUsersModal";
import { useAuthContext } from "../../../../hooks/Auth";

const SingleRoleUsers = () => {
  const { isLoadingUserRoles } = useSuperAdminUserRole();
  const { canAccess } = useAuthContext();
  const isNotProfessor = canAccess("delete:roleApps") && canAccess("create:roleApps");

  if (isLoadingUserRoles) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: 3,
        width: "100%",
        marginX: "auto",
        paddingX: 4,
      }}
    >
      {/* crear o eliminar usuarios */}
      {isNotProfessor && <Grid item>
        <HeadersUsersRole />
      </Grid>}

      {/* Tabla de usuarios */}
      <Grid item>
        <SingleRoleUsersTable />
      </Grid>

      {/* Modal para agregar ummiapps */}
      {canAccess("create:roleUsers") && <Grid item>
        <AddUserModal />
      </Grid>}

      {/* Modal para confirmar eliminar ummiapps */}
      {canAccess("delete:roleUsers") && <Grid item>
        <DeleteUsersModal />
      </Grid>}
    </Grid>
  );
};

export default SingleRoleUsers;
